<template>
  <div @contextmenu="onContext" style="width: 100%;">
    <v-row v-if="!isDisabledToolbar" class="px-2 py-1 customToolBar" v-bind:class="isFixedToolBar ? 'customToolBarFixed' : ''">
      <span v-if="!isDisabledAppend" class="text-black-bold" style="margin-top:4px;">行追加：</span>
      <!-- 行追加 -->
      <dd-icon-button-with-tooltip
        v-if="!isDisabledAppend"
        message="最終行の下に1行追加します"
        icon="mdi-plus-box-outline"
        @click="rowAppendSingle"
      />
      <dd-icon-button-with-tooltip
        v-if="!isDisabledAppend"
        message="最終行の下に複数行追加します"
        icon="mdi-plus-box-multiple-outline"
        @click="rowAppendDialog = true"
      />
      <v-dialog
        v-model="rowAppendDialog"
        width="340"
      >
        <v-card>
          <v-card-text>
            <v-container class="ma-0 pa-0">
              <v-row no-gutters style="background-color:#2D71BF;">
                <v-col :cols="12" class="px-1">
                  <div class="sps-section-title" style="color:#FFF">レコード追加（複数行）</div>
                  <hr class="sps-section-line" />
                </v-col>
              </v-row>
              <v-row no-gutters class="pb-2">
                <v-col cols="4">
                  <v-row no-gutters justify="end" class="pr-2">
                    <span style="padding-top: 6px !important">追加する行数:</span>
                  </v-row>
                </v-col>
                <v-col cols="3" class="px-1">
                  <v-text-field v-model="appendRow" @blur="onBlurAppendRow" class="right-input" type="number" hide-details outlined dense />
                </v-col>
              </v-row>
              <div class="mx-1" style="border: 1px solid #83BDE5;border-radius: 10px;">
                <span class="px-2"><b>入力補助</b></span>
                <hr style="border: 0.5px solid #83BDE5" />
                <v-row no-gutters class="px-1">
                  <dd-icon-button-with-tooltip color="green" icon="mdi-alpha-c-circle" @click="resetAppendRow" message="入力行数を初期化します。" />
                  <span class="ml-2" />
                  <span v-for="n in 9" :key="n">
                    <dd-icon-button color="primary" :icon="'mdi-numeric-' + n + '-circle-outline'" @click="overwriteAppendRow(n)" />
                  </span>
                  <dd-icon-button color="primary" icon="mdi-numeric-0-circle-outline" @click="overwriteAppendRow(0)" />
                </v-row>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters class="px-1">
              <dd-custom-button
                color="primary"
                :minWidth="100"
                @click="rowAppendDialog = false">
                キャンセル
              </dd-custom-button>
              <v-spacer />
              <dd-custom-button
                color="primary"
                :minWidth="100"
                :disabled="appendRow > 100"
                @click="rowAppendMulti">
                追加
              </dd-custom-button>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ツールバーカスタム -->
      <slot>
      </slot>
      <!-- ツールバーカスタム -->
      <!-- 表示切り替え -->
      <dd-transparent-button
        v-if="isChangeDisplay && !isDetailShow"
        color="primary"
        :minWidth="140"
        @click="onClickDetailShow">
        詳細項目を表示
        <v-icon>mdi-eye</v-icon>
      </dd-transparent-button>
      <dd-transparent-button
        v-if="isChangeDisplay && isDetailShow"
        color="primary"
        :minWidth="140"
        @click="onClickDetailHide">
        詳細項目を隠す
        <v-icon>mdi-eye-off</v-icon>
      </dd-transparent-button>
    </v-row>
    <div class="py-1 error--text" style="background-color:red; text-align: start; display: flex;" v-if="computedErrorListCnt > 0 || computedOutsideErrorListCnt > 0">
      <span class="ml-1" style="color:white"><v-icon color="white" small>mdi-alert-decagram-outline</v-icon>入力内容に不備があります。変更列に"ERR"の記載がある行を確認してください。</span>
    </div>
    <div @keydown="onkeydownSpreadSheet" ref="spreadsheet" />
    <dd-text-box
      v-show="showInputText"
      v-model="inputText"
      ref="inputText"
      :length="inputTextLength"
      :valueType="inputTextValueType"
      @blur="onBlurInput"
      @enter="onKeydownEnterInput"
      @tab="onKeydownTabInput"
      @esc="onKeydownTabInput"
    />
    <dd-numeric-box
      v-show="showInputNumeric"
      v-model="inputNumeric"
      ref="inputNumeric"
      :integerDigit="inputNumericIntDigit"
      :minorDigit="inputNumericDecimalDigit"
      :max="inputNumericMax"
      :min="inputNumericMin"
      :suffix="inputNumericSuffix"
      @blur="onBlurInput"
      @enter="onKeydownEnterInput"
      @tab="onKeydownTabInput"
      @esc="onKeydownTabInput"
    />
    <dd-date-box
      v-show="showInputDate"
      v-model="inputDate"
      ref="inputDate"
      @blur="onBlurInputDate"
      @change="onChangeInputDate"
      @close="onChangeInputDate"
      @enter="onKeydownEnterInput"
      @tab="onKeydownTabInput"
      @esc="onKeydownTabInput"
    />
    <dd-time-box
      v-show="showInputTime"
      v-model="inputTime"
      ref="inputTime"
      @blur="onBlurInput"
      @enter="onKeydownEnterInput"
      @tab="onKeydownTabInput"
    />
    <!--
    <dd-time-span-box
      v-show="showInputTimeSpan"
      v-model="inputTimeSpan"
      ref="inputTimeSpan"
      @blur="onBlurInput"
      @enter="onKeydownEnterInput"
      @tab="onKeydownTabInput"
    />
    -->
  </div>
</template>
<script>
import 'jsuites/dist/jsuites.js'
import 'jsuites/dist/jsuites.css'
import 'jspreadsheet-ce/dist/jspreadsheet.css'
import jSpreadSheet from 'jspreadsheet-ce'

import controls from '@/rahmen/controls'
// import complements from '@/rahmen/complement'
import filter from '@/rahmen/utils/filters'
import inputMixin from '@/mixins/inputMixins'
import message from '@/ddv2.library/messages'
import validators from '@/rahmen/validators'
import spsvalidator from '@/ddv2.library/validator4sps'
// import core from '@/rahmen/core'
// import dolly from '@/rahmen/utils/dolly'
import dayjs from 'dayjs'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdDateBox from '@/components/DdSpreadSheetDateBox.vue'
import DdNumericBox from '@/components/DdSpreadSheetNumericBox.vue'
import DdTextBox from '@/components/DdSpreadSheetTextBox.vue'
import DdTimeBox from '@/components/DdSpreadSheetTimeBox.vue'
import DdIconButton from '@/components/DdIconButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'

/**
 * @file datatec用スプレッドシート
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @example
  <dt-time-box
    label=""
    v-model="timeValue"
    ref="timeValue"
    displayFormat="HH:mm">
 */
export default {
  name: 'D2SpreadSheet',
  mixins: [inputMixin],
  props: {
    value: Array,
    column: Array,
    footer: Array,
    contextMenu: Function,
    // jspreadsheetのoption
    customOption: Object,
    // 読み取り状態
    isShoukaiMode: Boolean,
    // 外部から渡されるエラーリスト
    // { rowId: スプレッドシート行特定ID, x: -1(項番のこと), msg: エラーメッセージ }
    outsideErrorList: Array,
    // 削除ボタン 未検討
    options: Object,
    dropDownList: Array,
    height: {
      type: Number,
      default: 300
    },
    isChangeDisplay: {
      type: Boolean,
      default: false
    },
    // 右クリックの行追加を使用するか
    useAddRow: {
      type: Boolean,
      default: true
    },
    // 右クリックの行削除を使用するか
    useDeleteRow: {
      type: Boolean,
      default: false
    },
    // 右クリックの特殊追加を使用するか
    useAddCustom: {
      type: Boolean,
      default: false
    },
    addCustomText: {
      type: String,
      default: '追加'
    },
    //
    isDeleteBtn: {
      type: Boolean,
      default: false
    },
    isFixedToolBar: {
      type: Boolean,
      default: false
    },
    isDisabledToolbar: {
      type: Boolean,
      default: false
    },
    isDisabledAppend: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdDateBox,
    DdNumericBox,
    DdTextBox,
    DdTimeBox,
    DdIconButton,
    DdIconButtonWithTooltip
  },
  data: () => ({
    // dataSS: [],
    // validateエラーを格納
    errorList: [],
    // 内部データ変更中フラグ
    isDataChangeFlg: false,
    // 入力中フラグ
    isInputtingFlg: false,
    // 文字入力項目
    showInputText: false,
    inputText: null,
    inputTextLength: 0,
    inputTextValueType: 0,
    // 数値入力項目
    showInputNumeric: false,
    inputNumeric: null,
    inputNumericIntDigit: String(Number.MAX_SAFE_INTEGER).length,
    inputNumericDecimalDigit: 0,
    inputNumericMax: Number.MAX_SAFE_INTEGER,
    inputNumericMin: Number.MAX_SAFE_INTEGER * -1,
    inputNumericSuffix: null,
    // 日付入力項目
    showInputDate: false,
    inputDate: null,
    // 日付時刻入力項目
    showInputTime: false,
    inputTime: null,
    // 時間時刻入力項目
    showInputTimeSpan: false,
    inputTimeSpan: null,
    // 入力項目フォーカス前選択セル情報
    selectedCell: [],
    // 行追加用
    rowAppendDialog: false,
    appendRow: null,
    // 詳細表示用
    isDetailShow: false,
    // スクロールする時の比較用（ライブラリ？だと構造体に入れていないのでアクセスできなかった）
    scrollLeft: 0,
    testData: [[]]
  }),
  created () {
  },
  mounted () {
    // // 一度スプレッドシート内部データにコピー
    // this.dataSS = dolly.clone(this.value)
    this.setSpreadSheet()
  },
  computed: {
    computedDatas () {
      console.log('computedDatas', this.value)
      var rowId = 1
      return this.value.map(elem => {
        // 行を特定するIDを付与
        elem.rowIdForSS = rowId
        // 削除ボタン
        // 項目に削除ボタンを付与
        if (this.isDeleteBtn === true) {
          elem.deleteBtn = `<btn class="${elem.rowIdForSS} deleteBtn">削除</btn>`
        }
        rowId++
        return elem
      })
    },
    computedDatasNotDelete () {
      console.log('computedDatasNotDelete', this.computedDatas)
      return this.computedDatas.filter(elem => {
        return elem.deleteFlg !== true
      })
    },
    computedColumns () {
      var columns = this.column
      // 項目に削除ボタンを付与
      if (this.isDeleteBtn === true) {
        columns.push({ title: ' ', name: 'deleteBtn', type: null, customInput: null, customButton: 'deleteBtn', readOnly: true, width: '100px' })
      }
      // 項目にスプレッドシート用行特定IDを付与
      columns.push({ title: '', name: 'rowIdForSS', type: 'hidden', readOnly: true })

      return columns.map(elem => {
        // カスタム入力項目使用設定
        if (![undefined, null].includes(elem.customInput)) {
          if (elem.readOnly === true) {
            // カスタム入力項目の読み取り専用設定
            elem.customInput = null
          } else {
            // カスタム入力項目使用にあたってスプレッドシート標準の入力を封じる
            elem.readOnly = true
          }
        }
        // validate付与
        // validateXXXXがある場合はそちらを優先。ない場合はcustomXXXXより取得
        if (![undefined, null].includes(elem.validateType)) {
          elem.validInfo = {
            inputType: elem.validateType,
            length: ![undefined, null].includes(elem.validateLength) ? elem.validateLength : elem.customInputLength,
            intDigit: ![undefined, null].includes(elem.validateIntDigit) ? elem.validateIntDigit : elem.customInputIntDigit,
            decimalDigit: ![undefined, null].includes(elem.validateDecimalDigit) ? elem.validateDecimalDigit : elem.customInputDecimalDigit,
            max: elem.validateMax,
            min: elem.validateMin,
            isStraddle: elem.validateIsStraddle
          }
        }
        // クラス付与
        if (elem.customInput) {
          elem.class = 'customInput'
          if (['autocomplete', 'dropdown'].includes(elem.customInput)) elem.class = elem.class + ' jexcel_dropdown'
        }
        if (elem.name === 'rowIdForSS') {
          elem.class = 'rowId'
        }
        return elem
      })
    },
    computedDropDownList () {
      const target = this.dropDownList.find(f => {
        return f.code === this.selectedDropDownCode
      })
      if (!target) { return [] }
      return target.list
    },
    computedErrorList () {
      return this.errorList
    },
    computedErrorListCnt () {
      return this.computedErrorList.length
    },
    computedOutsideErrorListCnt () {
      return this.outsideErrorList.length
    }
  },
  watch: {
    value: function (n, o) {
      if (this.jspreadsheetObj) {
        console.log('watch value', this.value, n, o)
        // 選択セルを取得
        this.selectedCell = this.jspreadsheetObj.selectedCell
        this.setData(this.computedDatasNotDelete)
        if (this.selectedCell != null) {
          // 初期表示時や外部から表データを弄った時は選択セルがないから存在確認
          const left = this.selectedCell[0] || 0
          const top = this.selectedCell[1] || 0
          const right = this.selectedCell[2] || 0
          const bottom = this.selectedCell[3] || 0
          // 選択セルを選択し直す（表を作り直してるから選択解除になっている）
          this.updateSelectionFromCoords(left, top, right, bottom)
        }
      }
    },
    column: function (n, o) {
      this.reSetSpreadSheet()
    },
    outsideErrorList: function (n, o) {
      console.log('outsideErrorList')
      this.addTooltip(this.outsideErrorList)
    }
  },
  methods: {
    mergeValueData: function () {
      // 内部構造体データ
      const befData = this.computedDatas
      // スプレッドシートの構造体データ
      const aftData = this.getJson()
      var result = befData.map(bef => {
        var rowSS = aftData.find(aft => aft.rowIdForSS === bef.rowIdForSS)
        return { ...bef, ...rowSS }
      })
      return result
    },
    onAddRowButtonClick: function () {
      console.log('onAddRowButtonClick')
      var maxRowIdForSS = Math.max(...this.value.map(m => m.rowIdForSS)) + 1
      this.value.push({ rowIdForSS: maxRowIdForSS })
    },
    onDeleteRowButtonClick: function (e) {
      console.log('onDeleteRowButtonClick', e)
      const rowId = e.target.classList[0]
      const targetIdx = this.computedDatas.findIndex(elem => elem.rowIdForSS === Number(rowId))
      if (targetIdx !== -1) {
        const target = this.computedDatas.find(elem => elem.rowIdForSS === Number(rowId))
        if (target !== undefined) {
          // const keys = Object.keys(target)
          // if (keys.includes('deleteFlg')) {
          // }
          // 論理削除
          target.deleteFlg = true
          this.value.splice()
        }
      }
    },
    // ドロップダウン項目
    onDropdownButtonClick: function (e) {
      // console.log('onDropdownButtonClick', e)
      const cell = e.target
      this.jspreadsheetObj.openEditor(cell)
    },
    addClickEventDeleteButton: function () {
      const buttons = this.jspreadsheetObj.el.getElementsByClassName('deleteBtn')
      buttons.forEach(button => {
        // 作り直しているからクリックイベントを与えてあげなきゃ…
        button.onclick = this.onDeleteRowButtonClick
      })
    },
    /* ***** ***** ***** */
    /* pkg 操作関数 外側からも実行できるように */
    /* ***** ***** ***** */
    setSpreadSheet: function () {
      // refsで親画面から起動
      // console.log('setSpreadSheet')
      const self = this

      // 変更メモスタイル定義
      const addStyle = '<span style="color:white;font-size:0.7rem;padding:4px;background-color:green;border-radius:15px">ADD</span>'
      const updStyle = '<span style="color:white;font-size:0.7rem;padding:4px;background-color:green;border-radius:15px">UPD</span>'
      const delStyle = '<span style="color:white;font-size:0.75rem;padding:4px;background-color:#696969;border-radius:15px">DEL</span>'
      const errStyle = '<span style="color:white;font-size:0.75rem;padding:4px;background-color:red;border-radius:15px">ERR</span>'

      // スプレッドシートの設定データ
      var option = self.options
      // 高さを設定しないことで縦スクロールバーの表示を制御
      // option.tableHeight = null
      // ヘッダー
      option.columns = JSON.parse(JSON.stringify(self.computedColumns)) || []
      // 内容 はじめは空じゃないとインスタンス化する時に勝手にヘッダ作られることがある
      option.data = []
      // フッター
      option.footers = self.footer || null
      // コンテキストメニュー
      // option.contextMenu = self.contextMenu || null
      option.contextMenu = self.setContextMenu
      // changeイベント
      option.onchange = function (el, cell, x, y, value, oldValue) {
        console.log('onChange', el, cell, x, y, value, oldValue)
        self.deleteToolTip().then(() => {
          if (self.isInputtingFlg === false) {
            // // スプレッドシート内部データ反映
            // if (self.computedColumns.length >= x) {
            //   // 存在確認 列
            //   const targetCol = self.computedColumns[x]
            //   const targetColNm = targetCol.name
            //   // スプレッドシート内部データの行を特定するIDを取得
            //   const tr = cell.parentNode
            //   const rowId = tr.getElementsByClassName('rowId')
            //   // スプレッドシート内部データ対象行を特定
            //   const target = self.value.find(elem => elem.rowIdForSS === Number(rowId[0].textContent))
            //   // データ反映
            //   target[targetColNm] = value
            //   // watchイベント起きないから強制発火
            //   self.value.splice()
            // }
            // // 呼び出し元にイベント発火※独自検証処理を想定
            // if (value !== oldValue) {
            //   self.$emit('change', el, cell, x, y, value, oldValue)
            // }
            // 検証処理
            self.validate(cell, x, value).then(data => {
              self.customValidate(x, value).then(data2 => {
                const tr = cell.parentNode
                const rowId = tr.getElementsByClassName('rowId')[0].innerHTML
                const key = `${rowId}_${x}`
                console.log('setSpreadSheet validate', self.errorList)
                const targetIdx = self.errorList.findIndex(elem => elem.key === key)
                if (data.isErr) {
                  // self.$emit('valid:error', cell, x, y, value, data.msg)
                  // 同じ行同じ列のエラーは一度削除して更新
                  if (targetIdx !== -1) {
                    self.errorList.splice(targetIdx, 1)
                  }
                  var errorRow = {
                    key: key,
                    rowId: rowId,
                    x: x,
                    msg: data.msg
                  }
                  self.errorList.push(errorRow)
                } else {
                  if (data2.isErr) {
                    // self.$emit('valid:error', cell, x, y, value, data2.msg)
                    // 同じ行同じ列のエラーは一度削除して更新
                    if (targetIdx !== -1) {
                      self.errorList.splice(targetIdx, 1)
                    }
                    var errorRow2 = {
                      key: key,
                      rowId: rowId,
                      x: x,
                      msg: data2.msg
                    }
                    self.errorList.push(errorRow2)
                  } else {
                    // カスタム項目独自処理
                    if (self.isInputtingFlg === false) {
                      // 表示用の形式に変換する innerHTML
                      self.setDispInnerHTMLCustomInput(cell, value)
                    }
                    // self.$emit('valid:success', cell, x, y, value)
                    if (targetIdx !== -1) {
                      self.errorList.splice(targetIdx, 1)
                    }
                  }
                }
                // スプレッドシート内部データ反映
                if (self.computedColumns.length >= x) {
                  // 存在確認 列
                  const targetCol = self.computedColumns[x]
                  const targetColNm = targetCol.name
                  // スプレッドシート内部データの行を特定するIDを取得
                  const tr = cell.parentNode
                  const rowId = tr.getElementsByClassName('rowId')
                  // スプレッドシート内部データ対象行を特定
                  const target = self.value.find(elem => elem.rowIdForSS === Number(rowId[0].textContent))
                  // データ反映
                  target[targetColNm] = value
                  // 変更フラグ
                  target.editFlg = targetColNm !== 'editFlg' ? true : value
                  // 変更メモ
                  console.log('setSpreadSheet validate', self.errorList)
                  // セルではなく行で判断するように見直し
                  // const errIdx = self.errorList.findIndex(elem => elem.key === key)
                  const errIdx = self.errorList.findIndex(elem => elem.rowId === rowId[0].textContent)
                  target.errFlg = false
                  if (errIdx >= 0) {
                    target.memo = errStyle
                    target.errFlg = true
                  } else {
                    if (targetColNm !== 'editFlg') {
                      if (![undefined, null, ''].includes(target.delFlg) && target.delFlg === true) {
                        target.memo = delStyle
                      } else {
                        target.memo = target.id > 0 ? updStyle : addStyle
                      }
                      // 変更イベントを発行
                      self.$emit('change', el, cell, x, y, value, oldValue)
                    }
                  }

                  // jexcel_freezedが消えるので強制スクロール
                  /*
                  var obj = self.jspreadsheetObj
                  if (obj.content.scrollLeft + obj.content.clientWidth >= obj.content.scrollWidth) {
                    obj.content.scrollLeft = obj.content.scrollLeft - 1
                    obj.content.scrollLeft = obj.content.scrollLeft + 1
                  } else {
                    obj.content.scrollLeft = obj.content.scrollLeft + 1
                    obj.content.scrollLeft = obj.content.scrollLeft - 1
                  }
                  */

                  // watchイベント起きないから強制発火
                  self.value.splice()
                }
              })
            })
          }
        })
      }
      // insertrowイベント
      option.oninsertrow = function (el, rowNumber, numOfRows, rowRecords, insertBefore) {
        console.log('oninsertrow', el, rowNumber, numOfRows, rowRecords, insertBefore)
        // カスタム入力項目
        const addColumnClassList = self.computedColumns.filter((f, index) => {
          f.index = index
          return f.class != null
        })
        const customInputNums = self.computedColumns.filter((f, index) => {
          f.index = index
          return f.customInput != null
        }).map((m) => {
          return m.index
        })
        rowRecords.forEach(row => {
          // セルにcustomInputクラス付与
          self.addColumnClassByRowTdList(row, addColumnClassList)
          // カスタム入力項目
          self.reSetValueCustomInputByRowTdList(row, customInputNums)
        })
        // イベント発行 受け取ることがあれば
        self.$emit('insertrow', el, rowNumber, numOfRows, rowRecords, insertBefore)
      }
      // editionstartイベント
      option.oneditionstart = function (el, cell, x, y) {
        // console.log('oneditionstart', el, cell, x, y)
        self.openInputComponent(el, cell, x, y)
      }
      // selectionイベント
      option.onselection = function (el, borderLeft, borderTop, borderRight, borderBottom, origin) {
        // console.log('onselection', el, borderLeft, borderTop, borderRight, borderBottom, origin)
        self.closeInputComponent(el, borderLeft, borderTop, borderRight, borderBottom, origin)
      }
      // インスタンス化
      const jspreadsheetObj = jSpreadSheet(
        // DOM参照
        self.$refs.spreadsheet,
        // 表の設定データ
        option
      )
      // オブジェクトから thisに対してコピー
      Object.assign(this, { jspreadsheetObj })
      // 値セット
      self.setData(self.computedDatas)

      // 戻る機能とやり直す機能は不都合になりがちなので無効化
      this.jspreadsheetObj.ignoreHistory = true
      this.jspreadsheetObj.undo = function () { return true }
      this.jspreadsheetObj.redo = function () { return true }
      // カスタム入力項目であってもペーストできるように上書き
      this.jspreadsheetObj.paste = this.pasteOverride
      // カスタム入力項目であっても切り取りできるように上書き
      jSpreadSheet.cutControls = this.cutControlsOverride
      // ボタン項目(HTMLタグ)をコピーできないように上書き
      this.jspreadsheetObj.copy = this.copyOverride
      // // セルにcustomInputクラス付与
      // this.addColumnClass()
      // // カスタム入力項目
      // this.reSetValueCustomInput()
      // // 削除ボタン設定
      // this.settingDeleteBtn()

      // ID付与
      var tmp = document.getElementsByClassName('jexcel_content')
      // id属性追加
      tmp[0].setAttribute('id', 'v-jspreadsheet-0')
    },
    reSetSpreadSheet: function () {
      // refsで親画面から起動
      // console.log('reSetSpreadSheet')
      if (this.jspreadsheetObj) { this.jspreadsheetObj.destroy() }
      this.setSpreadSheet()
      return false
    },
    getJson: function () {
      // refsで親画面から起動
      // console.log('getJson')
      return this.jspreadsheetObj.getJson()
    },
    getData: function () {
      // refsで親画面から起動
      // console.log('getData')
      return this.jspreadsheetObj.getData()
    },
    getRowData: function (rowNum) {
      // refsで親画面から起動
      // console.log('getRowData', rowNum)
      return this.jspreadsheetObj.getRowData(rowNum)
    },
    getColumnData: function (colNum) {
      // refsで親画面から起動可能
      // console.log('getColumnData', colNum)
      return this.jspreadsheetObj.getColumnData(colNum)
    },
    setData: function (data) {
      // refsで親画面から起動可能
      console.log('setData', data)
      this.jspreadsheetObj.setData(data)
      // セルにcustomInputクラス付与
      this.addColumnClass()
      this.addHaderStyle()
      // カスタム入力項目
      this.reSetValueCustomInput()
      // 削除ボタン設定
      this.settingDeleteBtn()
      // エラーセルにツールチップを設定
      this.addTooltip(this.errorList)
      this.addTooltip(this.outsideErrorList)
      // 整備点検項目マスタ編集独自処理
      this.$emit('setDataAfter', this.computedDatas, this.getHtmlTrList())
    },
    setRowData: function (rowNum, data) {
      // refsで親画面から起動可能
      // console.log('setRowData', rowNum, data)
      return this.jspreadsheetObj.setRowData(rowNum, data)
    },
    getValue: function (cell, processedValue) {
      // refsで親画面から起動可能
      // console.log('getValue', cell, processedValue)
      return this.jspreadsheetObj.getValue(cell, processedValue)
    },
    getValueFromCoords: function (x, y, processedValue, columnType) {
      // refsで親画面から起動可能
      // console.log('getValueFromCoords', x, y, processedValue)
      var returnValue = this.jspreadsheetObj.getValueFromCoords(x, y, processedValue)
      // if (['dropdown', 'autocomplete'].includes(columnType)) {
      if (['dropdown'].includes(columnType)) {
        if (!isNaN(returnValue)) {
          returnValue = String(returnValue)
        }
        // ドロップダウン時は設定値を書き換え(':(コロン)'の前までを適用する)
        if (![undefined, null].includes(returnValue) && returnValue.indexOf(':') !== undefined) {
          returnValue = returnValue.substr(0, returnValue.indexOf(':'))
        } else {
          returnValue = null
        }
      }

      return returnValue
    },
    setValue: function (cell, value, force) {
      // refsで親画面から起動可能
      // console.log('setValue', cell, value, force)
      return this.jspreadsheetObj.setValue(cell, value, force)
    },
    setValueFromCoords: function (x, y, value, force) {
      // refsで親画面から起動可能
      // console.log('setValueFromCoords', x, y, value, force)
      return this.jspreadsheetObj.setValueFromCoords(x, y, value, force)
    },
    setStyle: function (x, y, styleKey, styleValue, force) {
      return this.jspreadsheetObj.setStyle('G2', styleKey, styleValue, force, true)
    },
    getCellFromCoords: function (x, y) {
      // refsで親画面から起動可能
      // console.log('getCellFromCoords', x, y)
      return this.jspreadsheetObj.getCellFromCoords(x, y)
    },
    resetSelection: function () {
      // refsで親画面から起動可能
      // console.log('resetSelection')
      return this.jspreadsheetObj.resetSelection()
    },
    updateSelectionFromCoords: function (left, top, right, bottom) {
      // refsで親画面から起動可能
      // console.log('updateSelectionFromCoords', left, top, right, bottom)
      return this.jspreadsheetObj.updateSelectionFromCoords(left, top, right, bottom)
    },
    setFooter: function (data) {
      // refsで親画面から起動可能
      // console.log('setFooter', data)
      this.jspreadsheetObj.setFooter(data)
      // フッターを設定すると以下のプロパティにフッターが格納されてしまう
      // 以下のプロパティに設定されるとフッターがあるという判定を受け、セルを更新する度にフッターの作り直しが行われてしまうっぽい
      // 作り直されるとツールチップを配置しても消去されてしまい、また制御も難しいため止めておくのが無難
      this.jspreadsheetObj.options.footers = null
      // this.addColumnClass()
    },
    customSetRowData: function (rowNum, data, force, notSetColNumList) {
      // refsで親画面から起動可能
      // console.log('customSetRowData', rowNum, data)
      var list = notSetColNumList || []
      for (var i = 0; i < this.jspreadsheetObj.headers.length; i++) {
        if (!list.includes(i)) {
          this.setValueFromCoords(i, rowNum, data[i], force)
        }
      }
      return true
    },
    getHtmlTrList: function () {
      // refsで親画面から起動可能
      // console.log('getHtmlTrList')
      return this.jspreadsheetObj.rows
    },
    getHtmlTfoot: function () {
      // refsで親画面から起動可能
      // console.log('getHtmlTfoot')
      return this.jspreadsheetObj.tfoot
    },
    showColumn: function (colNum) {
      return this.jspreadsheetObj.showColumn(colNum)
    },
    hideColumn: function (colNum) {
      return this.jspreadsheetObj.hideColumn(colNum)
    },
    /* ***** ***** ***** */
    /* validate 検証処理 */
    /* ***** ***** ***** */
    validate: function (cell, x, value) {
      // 検証処理
      return new Promise(resolve => {
        var target = {}
        var msg = null
        // ヘッダーから項目の情報を取得してvalidate処理を取得・設定
        const column = this.computedColumns[x]
        // 必須確認
        if (column.required) {
          target.value = value
          msg = validators.requireValidate(target)
          if (msg !== undefined) {
            // 検証処理でerror
            return resolve({ isErr: true, msg: msg })
          }
        }
        // 入力タイプ別検証処理
        var validatorList = []
        target = column.validInfo || {}
        if (target) {
          const list = controls.getInputTypeValidators(controls.InputTypes[target.inputType])
          validatorList = validatorList.concat(list)
        }

        if (validatorList.length > 0) {
          target.value = value
          // 必須確認じゃないから値がないなら検証処理しない で良いはず
          if (target.value === '' || target.value === null) { return resolve(false) }
          // 日付項目独自処理
          if (target.validateType === 'Date') {
            // 標準のcalendarでは日付項目がハイフン区切りのことがあるためスラッシュ区切りに変換してから検証処理を行う
            target.value = filter.dateFormatter(value)
          }

          for (let i = 0; i < validatorList.length; i++) {
            const f = validatorList[i]
            msg = f(target)
            if (msg !== undefined) {
              // 検証処理でerror
              return resolve({ isErr: true, msg: msg })
            }
            if (i === validatorList.length - 1) {
              // すべての検証処理でerrorなし
              resolve(false)
            }
          }
        } else {
          resolve(false)
        }
      })
    },
    customValidate: function (x, value) {
      return new Promise(resolve => {
        // ヘッダー項目情報を取得
        if (this.computedColumns.length < x) { return resolve(false) }
        const columnData = this.computedColumns[x]
        if (columnData.validateType === 'Time') {
          if (value === undefined || value === null || value === '') { return resolve(false) }
          // 時間フォーマットチェック（HH:mm:ssが標準validateにない）
          const valDate = spsvalidator.timeValidate(value)
          if (valDate === null) {
            // 検証処理でerror
            // resolve({ isErr: true, msg: message.get('DTBZMV03') })
            resolve({ isErr: true, msg: message.get('COMV0019', ['時刻']) })
          } else {
            resolve(false)
          }
        } else {
          resolve(false)
        }
      })
    },
    validateNoPromise: function (cell, x, value) {
      console.log('validate')
      // 検証処理
      var target = {}
      var msg = null
      // ヘッダーから項目の情報を取得してvalidate処理を取得・設定
      const column = this.computedColumns[x]
      // 必須確認
      if (column.required) {
        target.value = value
        msg = validators.requireValidate(target)
        if (msg !== undefined) {
          // 検証処理でerror
          return { isErr: true, msg: msg }
        }
      }
      // 入力タイプ別検証処理
      var validatorList = []
      target = column.validInfo || {}
      if (target) {
        const list = controls.getInputTypeValidators(controls.InputTypes[target.inputType])
        validatorList = validatorList.concat(list)
      }

      if (validatorList.length > 0) {
        target.value = value
        // 必須確認じゃないから値がないなら検証処理しない で良いはず
        if (target.value === '' || target.value === null) { return false }
        // 日付項目独自処理
        if (target.validateType === 'Date') {
          // 標準のcalendarでは日付項目がハイフン区切りのことがあるためスラッシュ区切りに変換してから検証処理を行う
          target.value = filter.dateFormatter(value)
        }

        for (let i = 0; i < validatorList.length; i++) {
          const f = validatorList[i]
          msg = f(target)
          if (msg !== undefined) {
            // 検証処理でerror
            return { isErr: true, msg: msg }
          }
          if (i === validatorList.length - 1) {
            // すべての検証処理でerrorなし
            return false
          }
        }
      } else {
        return false
      }
    },
    customValidateNoPromise: function (x, value) {
      // ヘッダー項目情報を取得
      if (this.computedColumns.length < x) { return false }
      const columnData = this.computedColumns[x]
      if (columnData.validateType === 'Time') {
        if (value === undefined || value === null || value === '') { return false }
        // 時間フォーマットチェック（HH:mm:ssが標準validateにない）
        const valDate = spsvalidator.timeValidate(value)
        if (valDate === null) {
          // 検証処理でerror
          // resolve({ isErr: true, msg: message.get('DTBZMV03') })
          return { isErr: true, msg: message.get('COMV0019', ['時刻']) }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // validateAllで呼ばれるように 中身は入力項目すべてをvalidate
    [controls.VALIDATE_METHOD]: function () {
      console.log('validateAll spreadSheet')
      const self = this
      const trList = self.getHtmlTrList()
      trList.forEach(tr => {
        var tdList = tr.querySelectorAll('td')
        tdList.forEach(td => {
          var x = td.dataset.x
          if (x !== undefined) {
            // 列番号が取得できる場合のみ 一番左の行番号列は列番号が取得できない

            var y = td.dataset.y
            var value = self.value[y][self.computedColumns[x].name]
            // changeイベント時に実行しているvalidateがpromise関数でvalidataAll時に通過してしまうためpromiseじゃない関数で実行
            // changeイベント時はちゃんと処理順序守って欲しい気持ちからpromise関数を使ってみたけどもしかしたら使わなくても良かったかも？
            var data = self.validateNoPromise(td, x, value)
            var data2 = self.customValidateNoPromise(x, value)
            if (!(td.classList.contains('readonly') && !td.classList.contains('customInput'))) {
              // const tr = td.parentNode
              const rowId = tr.getElementsByClassName('rowId')[0].innerHTML
              const key = `${rowId}_${x}`
              const targetIdx = self.errorList.findIndex(elem => elem.key === key)
              if (data.isErr) {
                // self.$emit('valid:error', td, x, y, value, data.msg)
                // 同じ行同じ列のエラーは一度削除して更新
                if (targetIdx !== -1) {
                  self.errorList.splice(targetIdx, 1)
                }
                var errorRow = {
                  key: key,
                  rowId: rowId,
                  x: x,
                  msg: data.msg
                }
                self.errorList.push(errorRow)
              } else {
                if (data2.isErr) {
                  // self.$emit('valid:error', td, x, y, value, data2.msg)
                  // 同じ行同じ列のエラーは一度削除して更新
                  if (targetIdx !== -1) {
                    self.errorList.splice(targetIdx, 1)
                  }
                  var errorRow2 = {
                    key: key,
                    rowId: rowId,
                    x: x,
                    msg: data2.msg
                  }
                  self.errorList.push(errorRow2)
                } else {
                  // self.$emit('valid:success', cell, x, y, value)
                  if (targetIdx !== -1) {
                    self.errorList.splice(targetIdx, 1)
                  }
                }
              }
            }
          }
        })
      })
      self.addTooltip(self.errorList)
    },
    [controls.GET_INVALID_METHOD]: function () {
      console.log('[controls.GET_INVALID_METHOD]')
      if (this.computedErrorListCnt > 0) {
        return false
      } else {
        return undefined
      }
    },
    [controls.CLEAR_INVALID_METHOD]: function () {
      this.errorList = []
      // this.reSetSpreadSheet()
    },
    /* ***** ***** ***** */
    /* ツールチップ 設定 */
    /* ***** ***** ***** */
    addTooltip: function (errorList) {
      console.log('addTooltip')
      return new Promise(resolve => {
        const self = this
        var trList = self.getHtmlTrList()
        for (var i = 0; i < trList.length; i++) {
          if (!trList[i].getElementsByClassName('rowId')[0]) { return }
          var rowId = trList[i].getElementsByClassName('rowId')[0].innerHTML
          var targetRow = errorList.filter(elem => elem.rowId === rowId)
          if (targetRow.length > 0) {
            var tdList = trList[i].querySelectorAll('td')
            // 項番セルが含まれるので1を調整
            for (var _i = 0; _i < tdList.length; _i++) {
              // forループ内でイベントリスナーを設定すると、クロージャの問題が発生し、意図しない結果が生じることがあります とのこと
              (function (index) {
                var targetCell = targetRow.find(elem => Number(elem.x) === index - 1)
                if (targetCell !== undefined) {
                  var errorMsg = targetCell.msg
                  var targetTd = tdList[index]
                  targetTd.classList.add('errorCell')
                  var tooltip
                  targetTd.addEventListener('mouseover', () => {
                    // 起点となってるぽいカード これが変わる度修正しないといけなさそうだなあ
                    var baseArea = document.getElementsByClassName('base-area')
                    var baseAreaRect = baseArea[0].getBoundingClientRect()
                    // 対象のセル
                    var targetRect = targetTd.getBoundingClientRect()
                    // 高さ算出
                    var positionY = (targetRect.top - 30) - baseAreaRect.top
                    // 横幅算出
                    var positionX = (targetRect.left - baseAreaRect.left)
                    tooltip = document.createElement('span')
                    tooltip.classList.add('tooltipmouseover')
                    tooltip.style.position = 'absolute'
                    tooltip.style.top = `${positionY}px`
                    tooltip.style.left = `${positionX}px`
                    tooltip.style.padding = '4px'
                    tooltip.style.backgroundColor = 'black'
                    tooltip.style.color = 'white'
                    tooltip.style.opacity = '0'
                    tooltip.style.transition = 'opacity 0.5s'
                    tooltip.style.zIndex = '10'
                    tooltip.innerText = errorMsg
                    self.jspreadsheetObj.el.getElementsByClassName('jexcel_content')[0].appendChild(tooltip)
                    setTimeout(() => {
                      tooltip.style.opacity = '0.7'
                    }, 500)
                  })
                  targetTd.addEventListener('mouseout', () => {
                    self.deleteToolTip()
                  })
                }
              })(_i)
            }
          }
          if (i === trList.length - 1) {
            resolve()
          }
        }
      })
    },
    deleteToolTip: function () {
      return new Promise(resolve => {
        const target = this.jspreadsheetObj.el.getElementsByClassName('tooltipmouseover')
        const length = target.length
        if (length > 0) {
          for (var i = 0; i < length; i++) {
            if (target[i]) {
              target[i].parentNode.removeChild(target[i])
            }
            if (i === length - 1) {
              resolve()
            }
          }
        } else {
          resolve()
        }
      })
    },
    /* ***** ***** ***** */
    /* カスタム入力項目 */
    /* ***** ***** ***** */
    openInputComponent: function (el, cell, x, y) {
      // console.log('openInputComponent', el, cell, x, y)
      if (this.isInputtingFlg === false) {
        // 入力中ではない場合（カスタム入力項目）
        // ヘッダー項目情報を取得
        if (this.computedColumns.length < x) { return }
        const columnData = this.computedColumns[x]
        if (columnData.customInput !== null) {
          // pkg外入力項目を使用する場合
          // 入力中にする
          this.isInputtingFlg = true
          // ヘッダー定義から操作対象の入力項目を特定
          var inputInfo = this.getInputComponentInfo(columnData.customInput)
          var showTargetName = inputInfo.showTargetName
          var refsTargetName = inputInfo.refsTargetName
          if (!showTargetName || !refsTargetName) { return }
          // 選択セルの既存設定値を設定
          this[refsTargetName] = this.getValueFromCoords(x, y, null, columnData.customInput)
          // テキスト
          if (columnData.customInput === 'text') {
            this.inputTextLength = columnData.customInputLength
            this.inputTextValueType = controls.InputTypes[columnData.customInputType]
          }
          // 数値
          if (columnData.customInput === 'numeric') {
            this.inputNumericIntDigit = columnData.customInputIntDigit
            this.inputNumericDecimalDigit = columnData.customInputDecimalDigit
            this.inputNumericMax = columnData.customInputMax
            this.inputNumericMin = columnData.customInputMin
            this.inputNumericSuffix = [undefined, null, ''].includes(columnData.customInputSuffix) ? null : columnData.customInputSuffix
          }
          // オートコンプリート
          if (columnData.customInput === 'autocomplete') {
            this.inputAutoCompleteHeaders = columnData.customItemHeaders
            this.inputAutoCompleteLists = columnData.customItemLists
            this.inputAutoCompleteValue = columnData.itemValue
            this.inputAutoCompleteText = columnData.itemText
          }
          // 選択セルの値を初期化
          if (columnData.customInput === 'dropdown') {
            this.inputDropDownLists = columnData.customItemLists
          }
          // this.setValueFromCoords(x, y, '', true)
          // 選択セルのinnerHTMLを初期化 値を初期化するとchangeイベントが走るのでよろしくない
          cell.innerHTML = ''
          // 選択セルに入力項目を配置
          cell.appendChild(this.$refs[refsTargetName].$el)
          // 入力項目を表示する
          this[showTargetName] = true
          // 入力項目にフォーカス
          const elem = this.$refs[refsTargetName]
          elem.focus()
          this.$nextTick(() => {
            // 選択セルを取得
            this.selectedCell = this.jspreadsheetObj.selectedCell
            // 選択セルを解除（入力項目にのみフォーカスを当てる意図）
            this.resetSelection()
          })
        }
      }
    },
    closeInputComponent: function (el, borderLeft, borderTop, borderRight, borderBottom, origin) {
      // console.log('closeInputComponent')
      if (this.isInputtingFlg === true) {
        // 入力中の場合（カスタム入力項目）
        // 親？をフォーカスすることで入力項目のフォーカスを外す
        el.focus()
        // 日付項目カレンダー操作のフォーカスで都合が悪いため念のため残ってたらblur処理を入れる
        // 入力項目セルを特定
        const inputInfo = this.getCurrentInputComponentInfo()
        const refsTargetName = inputInfo.refsTargetName
        if (!refsTargetName) { return }
        // 入力項目セルのHTML要素を取得
        var target = this.$refs[refsTargetName].$el
        if (!target) { return }
        const parentTd = target.closest('td')
        if (!parentTd) { return }
        this.blurProcess(parentTd)
      }
    },
    onBlurInput: function (e) {
      console.log('onBlurInput', e)
      if (this.isInputtingFlg === true) {
        // 入力中の場合（カスタム入力項目）
        const target = e.target
        if (!target) { return }
        const parentTd = target.closest('td')
        if (!parentTd) { return }
        this.blurProcess(parentTd)
      }
    },
    blurProcess: function (parentTd) {
      // console.log('blurProcess', parentTd)
      const self = this
      this.$nextTick(() => {
        // 項目位置情報
        const x = parentTd.getAttribute('data-x')
        const y = parentTd.getAttribute('data-y')
        // ヘッダー項目情報を取得
        if (this.computedColumns.length < x) { return }
        const columnData = this.computedColumns[x]
        // ヘッダー定義から操作対象の入力項目を特定
        var inputInfo = this.getInputComponentInfo(columnData.customInput)
        var showTargetName = inputInfo.showTargetName
        var refsTargetName = inputInfo.refsTargetName
        if (!showTargetName || !refsTargetName) { return }
        // 入力項目を非表示にする
        self[showTargetName] = false
        // 入力値を取得
        var value = null
        if (['inputDropDown'].includes(refsTargetName)) {
          // 詳細表示させるための変換
          const x = columnData.customItemLists.filter((item) => {
            return item.value === self[refsTargetName]
          })
          if (x.length > 0) value = x[0].text
        } else if (['inputAutoComplete'].includes(refsTargetName)) {
          const x = columnData.customItemLists.filter((item) => {
            return item[columnData.itemValue] === self[refsTargetName]
          })
          if (x.length > 0) value = x[0][columnData.itemText]
        } else {
          value = self[refsTargetName]
        }
        // 入力中をやめる
        self.isInputtingFlg = false
        // スプレッドシート入力対象セルに値を設定
        self.setValueFromCoords(x, y, value, true)
      })
    },
    // 日付項目
    onBlurInputDate: function (e) {
      // console.log('onBlurInputDate', e)
      // 日付項目独自処理
      if (this.isInputtingFlg === true) {
        // 入力中の場合（カスタム入力項目）
        const target = e.target
        if (!target) { return }
        const parentTd = target.closest('td')
        if (!parentTd) { return }
        const selectedCell = this.jspreadsheetObj.selectedCell
        if (!selectedCell) {
          var isShowCalendar = this.$refs.inputDate.isShowCalendar
          if (!isShowCalendar) {
            // カレンダーを開いていない場合 カレンダー, スプレッドシート内のセル以外をクリックした場合
            this.blurProcess(parentTd)
          }
          return
        }
        const blurX = parentTd.getAttribute('data-x')
        const blurY = parentTd.getAttribute('data-y')
        const currentX = selectedCell[2] || null
        const currentY = selectedCell[3] || null
        if (blurX !== currentX || blurY !== currentY) {
          // カレンダーが表示されていない状態とみなす
          this.blurProcess(parentTd)
        }
      }
    },
    // 日付項目
    onChangeInputDate: function (e) {
      // console.log('onChangeInputDate', e)
      if (this.isInputtingFlg === true) {
        // 入力中の場合（カスタム入力項目）
        const target = this.$refs.inputDate.$el
        if (!target) { return }
        const parentTd = target.closest('td')
        if (!parentTd) { return }
        // datepickerによる入力判定が厄介なため独自処理
        if (this.jspreadsheetObj.selectedCell === null) {
          // カレンダーで日付を選択としたとみなす
          this.blurProcess(parentTd)
        }
      }
    },
    // ドロップダウン項目
    onChangeInputDropDown: function (e) {
      console.log('onChangeInputDropDown', this.isInputtingFlg, 'e is', e)
      if (this.isInputtingFlg === true) {
      }
    },
    onKeydownEnterInput: function (e) {
      // console.log('onKeydownEnterInput', e)
      // 入力項目セルを特定
      const inputInfo = this.getCurrentInputComponentInfo()
      const refsTargetName = inputInfo.refsTargetName
      if (!refsTargetName) { return }
      // 入力項目セルのHTML要素を取得
      var target = this.$refs[refsTargetName].$el
      if (!target) { return }
      const parentTd = target.closest('td')
      if (!parentTd) { return }
      this.$nextTick(() => {
        // Enterで選択した値がcomponentに入るのを待つ
        // 選択リストが画面に残ってしまうのを消すための荒業
        parentTd.click()
        // 選択セルを入力項目フォーカス前に戻す
        const left = this.selectedCell[0] || 0
        const top = this.selectedCell[1] || 0
        const right = this.selectedCell[2] || 0
        const bottom = this.selectedCell[3] || 0
        this.updateSelectionFromCoords(left, top, right, bottom)
        // 選択セルが移動してしまうのを防ぐためイベント伝搬ストップ
        e.stopPropagation()
      })
    },
    onKeydownTabInput: function (e) {
      // console.log('onKeydownTabInput', e)
      // 入力項目セルを特定
      const inputInfo = this.getCurrentInputComponentInfo()
      const refsTargetName = inputInfo.refsTargetName
      if (!refsTargetName) { return }
      // 入力項目セルのHTML要素を取得
      var target = this.$refs[refsTargetName].$el
      if (!target) { return }
      const parentTd = target.closest('td')
      if (!parentTd) { return }
      this.$nextTick(() => {
        // Enterで選択した値がcomponentに入るのを待つ
        // 選択リストが画面に残ってしまうのを消すための荒業
        parentTd.click()
        // 選択セルを入力項目フォーカス前に戻す
        const left = this.selectedCell[0] || 0
        const top = this.selectedCell[1] || 0
        const right = this.selectedCell[2] || 0
        const bottom = this.selectedCell[3] || 0
        this.updateSelectionFromCoords(left, top, right, bottom)
        // if (e.shiftKey === true) {
        //   this.jspreadsheetObj.left(false, false)
        // } else {
        //   this.jspreadsheetObj.right(false, false)
        // }
        // // 選択セルが移動してしまうのを防ぐためイベント伝搬ストップ
        // e.stopPropagation()
      })
    },
    // カスタム入力項目情報取得
    getInputComponentInfo: function (inputType) {
      var result = {}
      if (inputType === 'text') {
        // 文字項目の場合
        result.showTargetName = 'showInputText'
        result.refsTargetName = 'inputText'
      }
      if (inputType === 'numeric') {
        // 数値項目の場合
        result.showTargetName = 'showInputNumeric'
        result.refsTargetName = 'inputNumeric'
      }
      if (inputType === 'date') {
        // 日付項目の場合
        result.showTargetName = 'showInputDate'
        result.refsTargetName = 'inputDate'
      }
      if (inputType === 'time') {
        // 日付時刻項目の場合
        result.showTargetName = 'showInputTime'
        result.refsTargetName = 'inputTime'
      }
      if (inputType === 'timespan') {
        // 時間時刻項目の場合
        result.showTargetName = 'showInputTimeSpan'
        result.refsTargetName = 'inputTimeSpan'
      }

      return result
    },
    // 現在のカスタム入力項目情報取得
    getCurrentInputComponentInfo: function () {
      var result = {}
      if (this.showInputText) {
        // 文字項目の場合
        result.showTargetName = 'showInputText'
        result.refsTargetName = 'inputText'
      }
      if (this.showInputNumeric) {
        // 数値項目の場合
        result.showTargetName = 'showInputNumeric'
        result.refsTargetName = 'inputNumeric'
      }
      if (this.showInputDate) {
        // 日付項目の場合
        result.showTargetName = 'showInputDate'
        result.refsTargetName = 'inputDate'
      }
      if (this.showInputTime) {
        // 日付時刻項目の場合
        result.showTargetName = 'showInputTime'
        result.refsTargetName = 'inputTime'
      }
      if (this.showInputTimeSpan) {
        // 時間時刻項目の場合
        result.showTargetName = 'showInputTimeSpan'
        result.refsTargetName = 'inputTimeSpan'
      }
      if (this.showInputAutoComplete) {
        // オートコンプリート項目の場合
        result.showTargetName = 'showInputAutoComplete'
        result.refsTargetName = 'inputAutoComplete'
      }
      if (this.showInputDropDown) {
        // ドロップダウン項目の場合
        result.showTargetName = 'showInputDropDown'
        result.refsTargetName = 'inputDropDown'
      }

      return result
    },
    /* ***** ***** ***** */
    /* カスタマイズ */
    /* ***** ***** ***** */
    // スプレッドシート keydownイベント
    onkeydownSpreadSheet: function (e) {
      // console.log('onkeydownSpreadSheet', e)
      if (e.key === 'Delete') {
        // deleteキーでカスタム入力項目の値を削除したいから無理やり
        if (this.isInputtingFlg === false) {
          const edition = this.jspreadsheetObj.edition
          const selectedCell = this.jspreadsheetObj.selectedCell
          if (!edition && selectedCell) {
            const highlighted = this.jspreadsheetObj.highlighted
            var target = highlighted.filter(elem => {
              var x = elem.getAttribute('data-x')
              // ヘッダー項目情報を取得
              if (this.computedColumns.length < x) { return }
              const columnData = this.computedColumns[x]
              return columnData.customInput !== null
            })
            this.setValue(target, '', true)
          }
        }
      }
    },
    // ヘッダークラス付与
    // カスタム入力項目用クラス付与 readonlyなので色を入力項目用に設定し直したい
    addColumnClass: function () {
      // console.log('addColumnClass')
      const addColumnClassList = this.computedColumns.filter((f, index) => {
        f.index = index
        return f.class != null
      })
      if (addColumnClassList.length <= 0) { return }
      // ヘッダ
      var thead = this.jspreadsheetObj.thead
      if (thead) {
        var trThead = thead.querySelector('tr')
        var tdListThead = trThead.querySelectorAll('td')
        this.addColumnClassByRowTdList(tdListThead, addColumnClassList)
      }
      // フッタ
      var tfoot = this.jspreadsheetObj.tfoot
      if (tfoot) {
        var trTfoot = tfoot.querySelector('tr')
        var tdListtrTfoot = trTfoot.querySelectorAll('td')
        this.addColumnClassByTfootTdList(tdListtrTfoot, addColumnClassList)
      }
      // セル
      if (this.jspreadsheetObj.rows.length <= 0) { return }
      this.jspreadsheetObj.rows.forEach(tr => {
        var tdList = tr.querySelectorAll('td')
        this.addColumnClassByRowTdList(tdList, addColumnClassList)
      })
    },
    addColumnClassByRowTdList: function (tdList, addColumnClassList) {
      tdList.forEach(td => {
        var x = td.getAttribute('data-x')
        var find = addColumnClassList.find(elem => elem.index === parseInt(x))
        if (find) {
          if (![undefined, null, ''].includes(find.class)) {
            const classes = find.class.split(' ')
            classes.forEach((item) => {
              td.classList.add(item)
            })
          }
        }
      })
    },
    addColumnClassByTfootTdList: function (tdList, addColumnClassList) {
      tdList.forEach((td, index) => {
        // 先頭は項番かつ調整のため-1
        var x = index - 1
        var find = addColumnClassList.find(elem => elem.index === parseInt(x))
        if (find) {
          td.classList.add(find.class)
        }
      })
    },

    // カスタムヘッダースタイル設定
    // *
    addHaderStyle: function () {
      const addHederStyleList = this.computedColumns.filter((f, index) => {
        f.index = index
        return f.headerStyle != null
      })
      const addHederClassList = this.computedColumns.filter((f, index) => {
        f.index = index
        return f.headerClass != null
      })
      if (addHederStyleList.length <= 0 && addHederClassList.length <= 0) { return }
      // ヘッダ
      var thead = this.jspreadsheetObj.thead
      if (thead) {
        var trThead = thead.querySelector('tr')
        var tdListThead = trThead.querySelectorAll('td')
        if (addHederStyleList.length > 0) this.addHeaderStyleByRowTdList(tdListThead, addHederStyleList)
        if (addHederClassList.length > 0) this.addHeaderClassByRowTdList(tdListThead, addHederClassList)
      }
    },
    addHeaderStyleByRowTdList: function (tdList, addHederStyleList) {
      tdList.forEach(td => {
        var x = td.getAttribute('data-x')
        var find = addHederStyleList.find(elem => elem.index === parseInt(x))
        if (find) {
          if (![undefined, null, ''].includes(find.headerStyle)) {
            td.style.cssText = td.style.cssText + ';' + find.headerStyle
          }
        }
      })
    },
    addHeaderClassByRowTdList: function (tdList, addColumnClassList) {
      tdList.forEach(td => {
        var x = td.getAttribute('data-x')
        var find = addColumnClassList.find(elem => elem.index === parseInt(x))
        if (find) {
          if (![undefined, null, ''].includes(find.headerClass)) {
            const classes = find.headerClass.split(' ')
            classes.forEach((item) => {
              td.classList.add(item)
            })
          }
        }
      })
    },
    // カスタム入力項目 日付、時間、数値項目を明示的に値設定（changeイベント走らせたい→重たいからやめる）
    reSetValueCustomInput: function () {
      // console.log('reSetValueCustomInput')
      const customInputNums = this.computedColumns.filter((f, index) => {
        f.index = index
        return ['numeric', 'date', 'time'].includes(f.customInput)
      }).map((m) => {
        return m.index
      })
      if (customInputNums.length <= 0) { return }
      if (this.jspreadsheetObj.rows.length <= 0) { return }
      this.jspreadsheetObj.rows.forEach(tr => {
        var tdList = tr.querySelectorAll('td')
        this.reSetValueCustomInputByRowTdList(tdList, customInputNums)
      })
    },
    reSetValueCustomInputByRowTdList: function (tdList, customInputNums) {
      tdList.forEach(td => {
        var x = td.getAttribute('data-x')
        if (customInputNums.includes(parseInt(x))) {
          var value = this.getValue(td)
          // innerHTMLを入力形式に変更するように修正
          // this.setValue(td, value || '', true)
          this.setDispInnerHTMLCustomInput(td, value)
        }
      })
    },
    // カスタム入力項目 innerHTMLに表示用形式変換後の値を設定
    setDispInnerHTMLCustomInput: function (parentTd, value) {
      // 項目位置情報
      const x = parentTd.getAttribute('data-x')
      // ヘッダー項目情報を取得
      if (this.computedColumns.length < x) { return }
      const columnData = this.computedColumns[x]
      if (columnData.validateType === 'Numerical') {
        // 数値項目
        parentTd.innerHTML = this.formatNumeric(value, columnData)
      }
      if (columnData.validateType === 'Date') {
        if (columnData.customFormat) {
          // 日付項目
          if (dayjs(value).isValid()) {
            parentTd.innerHTML = dayjs(value).format(columnData.customFormat)
          }
        }
      }
      if (columnData.validateType === 'Time') {
        if (columnData.customFormat) {
          // 時間項目
          if (value !== undefined && value !== null && value !== '') {
            if (dayjs(`2000/01/01 ${value}`).isValid()) {
              parentTd.innerHTML = dayjs(`2000/01/01 ${value}`).format(columnData.customFormat)
            }
          }
        }
      }
    },
    // 数値フォーマット（カンマ、小数点）
    formatNumeric: function (value, columnData) {
      const val = String(value)
      var formatedText = ''
      if (val === 'undefined' || val === '' || val === 'null') {
        return formatedText
      }
      // const num = columnData.validateDecimalDigit === 0 ? parseInt(val, 10) : parseFloat(val, 10)
      const num = parseFloat(val, 10)
      let formated = num.toLocaleString(undefined, { maximumFractionDigits: 20 })

      if (columnData.validateDecimalDigit === undefined) columnData.validateDecimalDigit = ![undefined, null].includes(columnData.customInputDecimalDigit) ? columnData.customInputDecimalDigit : 0

      if (columnData.validateDecimalDigit !== 0) {
        const dotPosition = formated.lastIndexOf('.')
        if (dotPosition === -1) {
          formated += `.${'0'.repeat(columnData.validateDecimalDigit)}`
        } else {
          const minorLen = formated.split('.')[1].length
          formated += '0'.repeat(columnData.validateDecimalDigit - minorLen)
        }
      }
      formatedText = formated + (![undefined, null].includes(columnData.customInputSuffix) ? ' ' + columnData.customInputSuffix : '')
      return formatedText
    },
    // 削除ボタン
    settingDeleteBtn: function () {
      // console.log('settingDeleteBtn')
      const deleteBtnNum = this.computedColumns.filter((f, index) => {
        f.index = index
        return f.type === 'dropdown'
      }).map((m) => {
        return m.index
      })
      if (deleteBtnNum.length <= 0) { return }
      if (this.jspreadsheetObj.rows.length <= 0) { return }
      this.jspreadsheetObj.rows.forEach(tr => {
        var tdList = tr.querySelectorAll('td')
        this.settingDeleteBtnByRowTdList(tdList, deleteBtnNum)
      })
    },
    settingDeleteBtnByRowTdList: function (tdList, deleteBtnNum) {
      tdList.forEach(td => {
        var x = td.getAttribute('data-x')
        if (deleteBtnNum.includes(parseInt(x))) {
          td.classList.add('dropdownBtn')
          td.onclick = this.onDropdownButtonClick
          // const btn = document.createElement('btn')
          // btn.classList.add('deleteBtn')
          // btn.innerHTML = '削除'
          // td.appendChild(btn)
        }
      })
    },
    //
    /* ***** ***** ***** */
    /* pkg カスタマイズ（上書き） */
    /* ***** ***** ***** */
    copyOverride: function (highlighted, delimiter, returnData, includeHeaders, download) {
      // 既存ソースをeslintに怒られないように想定通りの動きをするように調整して、都合の悪い箇所を修正
      if (!delimiter) {
        delimiter = '\t'
      }

      var div = new RegExp(delimiter, 'ig')

      // Controls
      var header = []
      var col = []
      var colLabel = []
      var row = []
      var rowLabel = []
      var x = this.jspreadsheetObj.options.data[0].length
      var y = this.jspreadsheetObj.options.data.length
      var tmp = ''
      var copyHeader = false
      var headers = ''
      var nestedHeaders = ''
      var numOfCols = 0
      var numOfRows = 0

      // Partial copy
      var copyX = 0
      var copyY = 0
      var isPartialCopy = true
      // Go through the columns to get the data
      for (var j = 0; j < y; j++) {
        for (var i = 0; i < x; i++) {
          // If cell is highlighted
          if (!highlighted || this.jspreadsheetObj.records[j][i].classList.contains('highlight')) {
            if (copyX <= i) {
              copyX = i
            }
            if (copyY <= j) {
              copyY = j
            }
          }
        }
      }
      if (x === copyX + 1 && y === copyY + 1) {
        isPartialCopy = false
      }

      if ((download && this.jspreadsheetObj.options.includeHeadersOnDownload === true) ||
        (!download && this.jspreadsheetObj.options.includeHeadersOnCopy === true && !isPartialCopy) || (includeHeaders)) {
        // Nested headers
        if (this.jspreadsheetObj.options.nestedHeaders && this.jspreadsheetObj.options.nestedHeaders.length > 0) {
          // Flexible way to handle nestedheaders
          if (!(this.jspreadsheetObj.options.nestedHeaders[0] && this.jspreadsheetObj.options.nestedHeaders[0][0])) {
            tmp = [this.jspreadsheetObj.options.nestedHeaders]
          } else {
            tmp = this.jspreadsheetObj.options.nestedHeaders
          }

          for (var _j = 0; _j < tmp.length; _j++) {
            var nested = []
            for (var _i = 0; _i < tmp[_j].length; _i++) {
              var colspan = parseInt(tmp[_j][_i].colspan)
              nested.push(tmp[_j][_i].title)
              for (var c = 0; c < colspan - 1; c++) {
                nested.push('')
              }
            }
            nestedHeaders += nested.join(delimiter) + '\r\n'
          }
        }

        copyHeader = true
      }

      // Reset container
      this.jspreadsheetObj.style = []

      // Go through the columns to get the data
      for (var __j = 0; __j < y; __j++) {
        col = []
        colLabel = []

        for (var __i = 0; __i < x; __i++) {
          // If cell is highlighted
          if (!highlighted || this.jspreadsheetObj.records[__j][__i].classList.contains('highlight')) {
            if (copyHeader === true) {
              header.push(this.jspreadsheetObj.headers[__i].textContent)
            }
            // Values
            var value = this.jspreadsheetObj.options.data[__j][__i]
            // *** edit start
            // カスタムボタン項目の場合はHTMLタグまでコピーできてしまうためコピー自体させない
            if (this.jspreadsheetObj.options.columns[__i].customButton) {
              value = ' '
            }
            // *** edit end
            if (value.match && (value.match(div) || value.match(/,/g) || value.match(/\n/) || value.match(/"/))) {
              value = value.replace(new RegExp('"', 'g'), '""')
              value = '"' + value + '"'
            }
            col.push(value)

            // Labels
            var label
            if (this.jspreadsheetObj.options.columns[__i].type === 'checkbox' || this.jspreadsheetObj.options.columns[__i].type === 'radio') {
              label = value
            } else {
              if (this.jspreadsheetObj.options.stripHTMLOnCopy === true) {
                label = this.jspreadsheetObj.records[__j][__i].textContent
              } else {
                label = this.jspreadsheetObj.records[__j][__i].innerHTML
              }
              if (label.match && (label.match(div) || label.match(/,/g) || label.match(/\n/) || label.match(/"/))) {
                // Scape double quotes
                label = label.replace(new RegExp('"', 'g'), '""')
                label = '"' + label + '"'
              }
            }
            colLabel.push(label)

            // Get style
            tmp = this.jspreadsheetObj.records[__j][__i].getAttribute('style')
            tmp = tmp.replace('display: none;', '')
            this.jspreadsheetObj.style.push(tmp || '')
          }
        }

        if (col.length) {
          if (copyHeader) {
            numOfCols = col.length
            row.push(header.join(delimiter))
          }
          row.push(col.join(delimiter))
        }
        if (colLabel.length) {
          numOfRows++
          if (copyHeader) {
            rowLabel.push(header.join(delimiter))
            copyHeader = false
          }
          rowLabel.push(colLabel.join(delimiter))
        }
      }

      if (x === numOfCols && y === numOfRows) {
        headers = nestedHeaders
      }

      // Final string
      var str = headers + row.join('\r\n')
      var strLabel = headers + rowLabel.join('\r\n')
      // Create a hidden textarea to copy the values
      if (!returnData) {
        if (this.jspreadsheetObj.options.copyCompatibility === true) {
          this.jspreadsheetObj.textarea.value = strLabel
        } else {
          this.jspreadsheetObj.textarea.value = str
        }
        this.jspreadsheetObj.textarea.select()
        document.execCommand('copy')
      }

      // Keep data
      if (this.jspreadsheetObj.options.copyCompatibility === true) {
        this.jspreadsheetObj.data = strLabel
      } else {
        this.jspreadsheetObj.data = str
      }
      // Keep non visible information
      this.jspreadsheetObj.hashString = this.jspreadsheetObj.hash(this.jspreadsheetObj.data)

      // Any exiting border should go
      if (!returnData) {
        this.jspreadsheetObj.removeCopyingSelection()

        // Border
        if (this.jspreadsheetObj.highlighted) {
          for (var ____i = 0; ____i < this.jspreadsheetObj.highlighted.length; ____i++) {
            this.jspreadsheetObj.highlighted[____i].classList.add('copying')
            if (this.jspreadsheetObj.highlighted[____i].classList.contains('highlight-left')) {
              this.jspreadsheetObj.highlighted[____i].classList.add('copying-left')
            }
            if (this.jspreadsheetObj.highlighted[____i].classList.contains('highlight-right')) {
              this.jspreadsheetObj.highlighted[____i].classList.add('copying-right')
            }
            if (this.jspreadsheetObj.highlighted[____i].classList.contains('highlight-top')) {
              this.jspreadsheetObj.highlighted[____i].classList.add('copying-top')
            }
            if (this.jspreadsheetObj.highlighted[____i].classList.contains('highlight-bottom')) {
              this.jspreadsheetObj.highlighted[____i].classList.add('copying-bottom')
            }
          }
        }

        // Paste event
        this.jspreadsheetObj.dispatch('oncopy', this.jspreadsheetObj.el, this.jspreadsheetObj.options.copyCompatibility === true ? rowLabel : row, this.jspreadsheetObj.hashString)
      }

      return this.jspreadsheetObj.data
    },
    pasteOverride: function (x, y, data) {
      // 既存ソースをeslintに怒られないように想定通りの動きをするように調整して、都合の悪い箇所を修正
      var obj = this.jspreadsheetObj
      // *** edit start
      // スタイルの貼り付けは不要
      // var jexcel = jSpreadSheet
      // *** edit end
      var el = this.jspreadsheetObj.el
      // Paste filter
      var ret = obj.dispatch('onbeforepaste', el, data, x, y)

      var vData = data
      if (ret === false) {
        return false
      } else if (ret) {
        vData = ret
      }

      // Controls
      var hash = obj.hash(vData)
      // *** edit start
      // スタイルの貼り付けは不要
      // var style = (hash === obj.hashString) ? obj.style : null
      // *** edit end

      // Depending on the behavior
      if (obj.options.copyCompatibility === true && hash === obj.hashString) {
        vData = obj.data
      }

      // Split new line
      vData = obj.parseCSV(vData, '\t')

      if (x != null && y != null && vData) {
        // Records
        var i = 0
        var j = 0
        var records = []
        var newStyle = {}
        var oldStyle = {}
        // *** edit start
        // スタイルの貼り付けは不要
        // var styleIndex = 0
        // *** edit end

        // Index
        var colIndex = parseInt(x)
        var rowIndex = parseInt(y)
        var row = null

        // Go through the columns to get the data
        while (vData[j]) {
          row = vData[j]
          i = 0
          colIndex = parseInt(x)

          while (row[i] != null) {
            // Update and keep history
            // *** edit start
            // ヘッダー項目情報を取得
            if (this.computedColumns.length < colIndex) { break }
            const columnData = this.computedColumns[colIndex]
            // カスタム入力項目は便宜上readonlyなので強制的にペーストしたい
            // var record = obj.updateCell(colIndex, rowIndex, row[i])
            var record = null
            if (columnData.customInput != null) {
              record = obj.updateCell(colIndex, rowIndex, row[i], true)
            } else {
              record = obj.updateCell(colIndex, rowIndex, row[i])
            }
            // *** edit end
            // Keep history
            records.push(record)
            // Update all formulas in the chain
            obj.updateFormulaChain(colIndex, rowIndex, records)
            // *** edit start
            // スタイルの貼り付けは不要
            // Style
            // if (style && style[styleIndex]) {
            //   var columnName = jexcel.getColumnNameFromId([colIndex, rowIndex])
            //   newStyle[columnName] = style[styleIndex]
            //   oldStyle[columnName] = obj.getStyle(columnName)
            //   obj.records[rowIndex][colIndex].setAttribute('style', style[styleIndex])
            //   styleIndex++
            // }
            // *** edit end
            i++
            if (row[i] != null) {
              if (colIndex >= obj.headers.length - 1) {
                // If the pasted column is out of range, create it if possible
                if (obj.options.allowInsertColumn === true) {
                  // *** edit start
                  // ペーストによる列追加許さない（コメント化）
                  // obj.insertColumn()
                  // *** edit end
                  // Otherwise skip the pasted data that overflows
                } else {
                  break
                }
              }
              colIndex = obj.right.get(colIndex, rowIndex)
            }
          }

          j++
          if (vData[j]) {
            if (rowIndex >= obj.rows.length - 1) {
              // If the pasted row is out of range, create it if possible
              if (obj.options.allowInsertRow === true) {
                // *** edit start
                // ペーストによる列追加許さない（コメント化）
                // obj.insertRow()
                // *** edit end
                // Otherwise skip the pasted data that overflows
              } else {
                break
              }
            }
            rowIndex = obj.down.get(x, rowIndex)
          }
        }

        // Select the new cells
        obj.updateSelectionFromCoords(x, y, colIndex, rowIndex)

        // Update history
        obj.setHistory({
          action: 'setValue',
          records: records,
          selection: obj.selectedCell,
          newStyle: newStyle,
          oldStyle: oldStyle
        })

        // Update table
        obj.updateTable()

        // Paste event
        obj.dispatch('onpaste', el, vData)

        // On after changes
        obj.onafterchanges(el, records)
      }

      obj.removeCopyingSelection()
    },
    cutControlsOverride: function (e) {
      // 既存ソースをeslintに怒られないように想定通りの動きをするように調整して、都合の悪い箇所を修正
      console.log('cutControlsOverride', e)
      var jexcel = jSpreadSheet
      if (jexcel.current) {
        if (!jexcel.current.edition) {
          jexcel.current.copy(true)
          if (jexcel.current.options.editable === true) {
            const targetCell = jexcel.current.highlighted
            console.log('cutControlsOverride targetCell', targetCell)
            targetCell.forEach(elem => {
              var targetCellClassList = elem.classList
              if (!targetCellClassList.contains('readOnly')) {
                // readOnlyじゃない時は切り取り
                jexcel.current.setValue(elem, '', true)
              }
            })
          }
        }
      }
    },
    updateScrollOverride: function (direction) {
      // 既存ソースをeslintに怒られないように想定通りの動きをするように調整して、都合の悪い箇所を修正
      var obj = this.jspreadsheetObj

      // Jspreadsheet Container information
      var contentRect = obj.content.getBoundingClientRect()
      var x1 = contentRect.left
      var y1 = contentRect.top
      var w1 = contentRect.width
      var h1 = contentRect.height

      // Direction Left or Up
      var reference = obj.records[obj.selectedCell[3]][obj.selectedCell[2]]

      // Reference
      var referenceRect = reference.getBoundingClientRect()
      var x2 = referenceRect.left
      var y2 = referenceRect.top
      var w2 = referenceRect.width
      var h2 = referenceRect.height

      // *** edit start
      // ヘッダーの高さ
      var thead = obj.content.getElementsByTagName('thead')
      var h3 = thead[0].clientHeight
      // *** edit end

      // *** edit start
      // 横スクロールバーの高さ
      var el = this.jspreadsheetObj.content
      var scrollH = el.offsetHeight - el.clientHeight
      // *** edit end

      // Direction
      var x = 0
      var y = 0
      if (direction === 0 || direction === 1) {
        x = (x2 - x1) + obj.content.scrollLeft
        y = (y2 - y1) + obj.content.scrollTop - 2
      } else {
        x = (x2 - x1) + obj.content.scrollLeft + w2
        y = (y2 - y1) + obj.content.scrollTop + h2
      }

      // Top position check
      if (y > (obj.content.scrollTop + 30) && y < (obj.content.scrollTop + h1)) {
        // In the viewport
      } else {
        // Out of viewport
        if (y < obj.content.scrollTop + 30) {
          console.log('scroll 001', y, obj.content.scrollTop, h3, h2, h1)
          // *** edit start
          // obj.content.scrollTop = y - h2
          obj.content.scrollTop = y - h3
          // *** edit end
        } else {
          console.log('scroll 002', y, obj.content.scrollTop, h3, h2, h1)
          // *** edit start
          // obj.content.scrollTop = y - (h1 - 2)
          obj.content.scrollTop = y - (h1 - 2) + scrollH
          // *** edit end
        }
      }

      // Freeze columns?
      var freezed = obj.getFreezeWidth()

      // Left position check - TODO: change that to the bottom border of the element
      if (x > (obj.content.scrollLeft + freezed) && x < (obj.content.scrollLeft + w1)) {
        // In the viewport
        // console.log('In the viewport', x, obj.content.scrollLeft, freezed, w1)
      } else {
        // Out of viewport
        // *** edit start
        // 謎の固定値30を辞めてみたら想定したような動きになった
        // if (x < obj.content.scrollLeft + 30) {
        if (x < obj.content.scrollLeft) {
        // *** edit end
          // console.log('Out of viewport 01', x, obj.content.scrollLeft, freezed)
          obj.content.scrollLeft = x
          if (obj.content.scrollLeft < 50) {
            obj.content.scrollLeft = 0
          }
        } else if (x < obj.content.scrollLeft + freezed) {
          // console.log('Out of viewport 02', x, obj.content.scrollLeft, freezed)
          obj.content.scrollLeft = x - freezed - 1
        } else {
          // console.log('Out of viewport 03', x, obj.content.scrollLeft, freezed, w1)
          obj.content.scrollLeft = x - (w1 - 20)
        }
      }
    },
    scrollControlsOverride: function (e) {
      // edit start
      // ヘッダーが複数行の場合、ヘッダー全ての行をstickeyになるように高さを設定したい
      // setSpreadSheet時に実行したかったが描画が終わってないのか高さが取得できず、高さを取得できる都合のつくタイミングがここくらいしかなかった
      // フラグ持たせて初回だけ動くようにしても良さそうだけど、重たくならないなら毎回走っても大丈夫かなきっと…
      this.settingAllHeaderStickey()
      // edit end
      this.jspreadsheetObj.wheelControls()

      // edit start
      // if (obj.options.freezeColumns > 0 && obj.content.scrollLeft != scrollLeft) {
      //     obj.updateFreezePosition();
      // }
      if (this.jspreadsheetObj.options.freezeColumns > 0 && this.jspreadsheetObj.content.scrollLeft !== this.scrollLeft) {
        this.updateFreezePositionOverride()
      }
      // edit end

      // Close editor
      if (this.jspreadsheetObj.options.lazyLoading === true || this.jspreadsheetObj.options.tableOverflow === true) {
        if (this.jspreadsheetObj.edition && e.target.className.substr(0, 9) !== 'jdropdown') {
          this.jspreadsheetObj.closeEditor(this.jspreadsheetObj.edition[0], true)
        }
      }
    },
    updateFreezePositionOverride: function () {
      this.scrollLeft = this.jspreadsheetObj.content.scrollLeft
      // edit start
      var isFooter = false
      var tFoot = this.jspreadsheetObj.tfoot
      if (tFoot) {
        // フッターにtr複数設定が可能っぽいけど普通1行なので1行前提で
        var tr = tFoot.querySelector('tr')
        if (tr) {
          var tdList = tr.querySelectorAll('td')
          isFooter = true
        }
      }
      // edit end
      var width = 0
      if (this.scrollLeft > 50) {
        for (var i = 0; i < this.jspreadsheetObj.options.freezeColumns; i++) {
          if (i > 0) {
            // Must check if the previous column is hidden or not to determin whether the width shoule be added or not!
            if (this.jspreadsheetObj.options.columns[i - 1].type !== 'hidden') {
              width += parseInt(this.jspreadsheetObj.options.columns[i - 1].width)
            }
          }
          this.jspreadsheetObj.headers[i].classList.add('jexcel_freezed')
          this.jspreadsheetObj.headers[i].style.left = width + 'px'
          // edit start
          if (isFooter === true) {
            // 項番セルは無視する仕様ぽいので無視する
            tdList[i + 1].classList.add('jexcel_freezed')
            tdList[i + 1].style.left = width + 'px'
          }
          // edit end
          for (var j = 0; j < this.jspreadsheetObj.rows.length; j++) {
            if (this.jspreadsheetObj.rows[j] && this.jspreadsheetObj.records[j][i]) {
              var shifted = (this.scrollLeft + (i > 0 ? this.jspreadsheetObj.records[j][i - 1].style.width : 0)) - 51 + 'px'
              this.jspreadsheetObj.records[j][i].classList.add('jexcel_freezed')
              this.jspreadsheetObj.records[j][i].style.left = shifted
            }
          }
        }
      } else {
        for (var _i = 0; _i < this.jspreadsheetObj.options.freezeColumns; _i++) {
          this.jspreadsheetObj.headers[_i].classList.remove('jexcel_freezed')
          this.jspreadsheetObj.headers[_i].style.left = ''
          // edit start
          if (isFooter === true) {
            // 項番セルは無視する仕様ぽいので無視する
            tdList[_i + 1].classList.remove('jexcel_freezed')
            tdList[_i + 1].style.left = ''
          }
          // edit end
          for (var _j = 0; _j < this.jspreadsheetObj.rows.length; _j++) {
            if (this.jspreadsheetObj.records[_j][_i]) {
              this.jspreadsheetObj.records[_j][_i].classList.remove('jexcel_freezed')
              this.jspreadsheetObj.records[_j][_i].style.left = ''
            }
          }
        }
      }

      // Place the corner in the correct place
      this.jspreadsheetObj.updateCornerPosition()
    },
    /* ***** ***** ***** */
    /* その他 */
    /* ***** ***** ***** */
    onContext: function () {
      // スプレッドシートには右クリックがあるためブラウザの右クリックは禁止
      event.preventDefault()
    },
    /* スプレッドシート コンテキストメニュー--> */
    setContextMenu: function (obj, x, y, e) {
      console.log('setContextMenu', obj, x, y, e)
      // 読み取りモードならコンテキストメニュー出さない
      if (this.isShoukaiMode) { return false }

      const self = this
      var items = []
      // 各種機能
      var insert = null
      var del = null
      var copy = null
      var paste = null
      var addJuchu = null
      // 区切り線
      var line = { type: 'line' }

      if (y === null) {
        // ヘッダー選択
      }
      if (y !== null) {
        // ヘッダー選択以外

        // 選択行数判定
        // var selectedRowCnt = obj.getSelectedRows().length
        // if (selectedRowCnt === 1) {
        // 1行のみ選択されている場合
        // 追加
        if (self.useAddRow) {
          // 行追加使用
          insert = {
            title: '行追加',
            onclick: function () {
              // 指定行の後ろに追加
              self.$emit('addRow', Number(y))
            }
          }
        }
        // 削除
        if (self.useDeleteRow) {
          // 行削除使用
          // 未検討
          // del = {
          //   title: '行削除',
          //   onclick: function () {
          //     var trList = self.getHtmlTrList()
          //     var rowId = trList[y].getElementsByClassName('rowId')[0].innerHTML
          //     // 一旦削除ボタンに合わせる
          //     var param = {
          //       target: {
          //         classList: [rowId]
          //       }
          //     }
          //     self.onDeleteRowButtonClick(param)
          //   }
          // }
        }
        // }
        if (self.useAddCustom) {
          // 特殊追加
          addJuchu = {
            title: self.addCustomText,
            onclick: function () {
              // 指定行の後ろに追加
              self.$emit('addRowCustom', Number(y))
            }
          }
        }
      }
      // コピー
      copy = {
        title: 'コピー',
        shortcut: 'Ctrl + C',
        onclick: function () {
          obj.copy(true)
        }
      }
      // 貼り付け
      if (navigator && navigator.clipboard && navigator.clipboard.readText) {
        // コピー済？
        paste = {
          title: '貼り付け',
          shortcut: 'Ctrl + V',
          onclick: function () {
            if (obj.selectedCell) {
              navigator.clipboard.readText().then(function (text) {
                if (text) {
                  obj.paste(obj.selectedCell[0], obj.selectedCell[1], text)
                }
              })
            }
          }
        }
      }
      // コンテキストメニュー内容設定
      if (addJuchu !== null) {
        items.push(addJuchu)
        items.push(line)
      }
      if (insert !== null) { items.push(insert) }
      if (del !== null) { items.push(del) }
      if (insert !== null || del !== null) { items.push(line) }
      if (copy) { items.push(copy) }
      if (paste !== null) { items.push(paste) }
      return items
    },
    rowAppendSingle: function () {
      this.$emit('addRow', 1)
    },
    rowAppendMulti: function () {
      this.onBlurAppendRow()
      this.rowAppendDialog = false
      this.$emit('addRow', this.appendRow)
    },
    onBlurAppendRow: function () {
      // 行追加は最大100行まで
      if ([undefined, null, ''].includes(this.appendRow)) this.appendRow = 1
      if (this.appendRow > 100) this.appendRow = 100
    },
    resetAppendRow: function () {
      this.appendRow = null
    },
    overwriteAppendRow: function (num) {
      if ([null, ''].includes(this.appendRow)) {
        this.appendRow = num
      } else {
        this.appendRow = this.appendRow + '' + num
      }
    },
    onClickDetailShow: function () {
      this.isDetailShow = true
      this.$emit('showColumns')
    },
    onClickDetailHide: function () {
      this.isDetailShow = false
      this.$emit('hideColumns')
    },
    onDummyFunction: function () {
      return null
    }
    /* 元のソース部分？
    titleに該当するところをインスタンス作成時に設定してあげると日本語化することはできそう
        // Context menu
        if (options && options.contextMenu != null) {
            obj.options.contextMenu = options.contextMenu;
        } else {
            obj.options.contextMenu = function(el, x, y, e) {
                var items = [];

                if (y == null) {
                    // Insert a new column
                    if (obj.options.allowInsertColumn == true) {
                        items.push({
                            title:obj.options.text.insertANewColumnBefore,
                            onclick:function() {
                                obj.insertColumn(1, parseInt(x), 1);
                            }
                        });
                    }

                    if (obj.options.allowInsertColumn == true) {
                        items.push({
                            title:obj.options.text.insertANewColumnAfter,
                            onclick:function() {
                                obj.insertColumn(1, parseInt(x), 0);
                            }
                        });
                    }

                    // Delete a column
                    if (obj.options.allowDeleteColumn == true) {
                        items.push({
                            title:obj.options.text.deleteSelectedColumns,
                            onclick:function() {
                                obj.deleteColumn(obj.getSelectedColumns().length ? undefined : parseInt(x));
                            }
                        });
                    }

                    // Rename column
                    if (obj.options.allowRenameColumn == true) {
                        items.push({
                            title:obj.options.text.renameThisColumn,
                            onclick:function() {
                                obj.setHeader(x);
                            }
                        });
                    }

                    // Sorting
                    if (obj.options.columnSorting == true) {
                        // Line
                        items.push({ type:'line' });

                        items.push({
                            title:obj.options.text.orderAscending,
                            onclick:function() {
                                obj.orderBy(x, 0);
                            }
                        });
                        items.push({
                            title:obj.options.text.orderDescending,
                            onclick:function() {
                                obj.orderBy(x, 1);
                            }
                        });
                    }
                } else {
                    // Insert new row
                    if (obj.options.allowInsertRow == true) {
                        items.push({
                            title:obj.options.text.insertANewRowBefore,
                            onclick:function() {
                                obj.insertRow(1, parseInt(y), 1);
                            }
                        });

                        items.push({
                            title:obj.options.text.insertANewRowAfter,
                            onclick:function() {
                                obj.insertRow(1, parseInt(y));
                            }
                        });
                    }

                    if (obj.options.allowDeleteRow == true) {
                        items.push({
                            title:obj.options.text.deleteSelectedRows,
                            onclick:function() {
                                obj.deleteRow(obj.getSelectedRows().length ? undefined : parseInt(y));
                            }
                        });
                    }

                    if (x) {
                        if (obj.options.allowComments == true) {
                            items.push({ type:'line' });

                            var title = obj.records[y][x].getAttribute('title') || '';

                            items.push({
                                title: title ? obj.options.text.editComments : obj.options.text.addComments,
                                onclick:function() {
                                    var comment = prompt(obj.options.text.comments, title);
                                    if (comment) {
                                        obj.setComments([ x, y ], comment);
                                    }
                                }
                            });

                            if (title) {
                                items.push({
                                    title:obj.options.text.clearComments,
                                    onclick:function() {
                                        obj.setComments([ x, y ], '');
                                    }
                                });
                            }
                        }
                    }
                }

                // Line
                items.push({ type:'line' });

                // Copy
                items.push({
                    title:obj.options.text.copy,
                    shortcut:'Ctrl + C',
                    onclick:function() {
                        obj.copy(true);
                    }
                });

                // Paste
                if (navigator && navigator.clipboard) {
                    items.push({
                        title:obj.options.text.paste,
                        shortcut:'Ctrl + V',
                        onclick:function() {
                            if (obj.selectedCell) {
                                navigator.clipboard.readText().then(function(text) {
                                    if (text) {
                                        jexcel.current.paste(obj.selectedCell[0], obj.selectedCell[1], text);
                                    }
                                });
                            }
                        }
                    });
                }

                // Save
                if (obj.options.allowExport) {
                    items.push({
                        title: obj.options.text.saveAs,
                        shortcut: 'Ctrl + S',
                        onclick: function () {
                            obj.download();
                        }
                    });
                }

                // About
                if (obj.options.about) {
                    items.push({
                        title:obj.options.text.about,
                        onclick:function() {
                            if (obj.options.about === true) {
                                alert(Version().print());
                            } else {
                                alert(obj.options.about);
                            }
                        }
                    });
                }

                return items;
            }
        }
    */
  }
}
</script>
<style scoped>
</style>
<style>
.jexcel_container {
  width: 100%;
}
table.jexcel {
  white-space: pre;
}
table.jexcel thead {
  word-break: break-word;
}
.jexcel_container {
  padding-left: none;
  padding-right: none;
  padding-top: none;
  padding-bottom: 10px;
  margin: auto;
}

.jexcel thead .jexcel_freezed, .jexcel tfoot .jexcel_freezed {
    left: 0px;
    z-index: 10 !important;
    box-shadow: 2px 0px 2px 0.2px #ccc !important;
    -webkit-box-shadow: 2px 0px 2px 0.2px #ccc !important;
    -moz-box-shadow: 2px 0px 2px 0.2px #ccc !important;
}

.jexcel tbody .jexcel_freezed {
    position: relative;
    background-color: #fff;
    box-shadow: 1px 1px 1px 1px #ccc;
    -webkit-box-shadow: 2px 4px 4px 0.1px #ccc;
    -moz-box-shadow: 2px 4px 4px 0.1px #ccc;
    z-index: 5;
}

.jexcel > tbody > tr > td.readonly.customInput {
  color: black;
  margin: 0px !important;
  padding: 0px !important;
}
.jexcel > tbody > tr > td.readonly:not(.customInput) {
  color: black;
  background-color: #f3f3f3!important;
  margin: 0px !important;
  padding: 0px !important;
}
.jexcel_content::-webkit-scrollbar {
  width: 0.75rem;
  height: 0.75rem;
}
.jexcel_pagination_dropdown {
  border: 1px solid #ccc !important;
  margin-left: 4px !important;
  padding: 2px 30px 2px 2px!important;
  width: 65px !important;
  text-align: right;
  background-repeat: no-repeat !important;
  background-position:top 50% right 5px !important;
  background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='lightgray'/%3E%3C/svg%3E") !important;
  text-overflow: ellipsis !important;
  overflow-x:hidden !important;
}
.jexcel_search {
  border: 1px solid #ccc !important;
  padding: 2px !important;
  width: 250px !important;
}
.jexcel_content {
  /* ツールチップ用に… */
  /* position: relative; */
  position: initial;
  box-shadow: none!important;
  scrollbar-width: initial;
  scrollbar-color: #83bde5 #eff6fd;
}
.jexcel_content .deleteBtn {
  cursor: pointer;
  display: block;
  width: 100%;
  background-color: #ffb3b3;
  border-bottom: 3px solid #ff4d4d;
}
.jexcel_content .deleteBtn:active {
  cursor: pointer;
  display: block;
  width: 100%;
  margin-top: 2px;
  background-color: #ffb3b3;
  border-bottom: 1px solid #ff4d4d;
}
.jexcel_content table {
  /* セル内に配置するボタン項目の高さを高さいっぱいにするために親のヘイトを指定？ */
  height: 100%;
}
.jexcel_pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
    padding-top: 20px;
}
/*
.jexcel_content .dropdownBtn {
  cursor: pointer;
  display: block;
  width: 100%;
  height: 100%;
  margin: 0px !important;
  padding: 0px !important;
  padding-top: 4px !important;
  color: #1F2B38;
  /* 以下はjexcel_dropdownを参考 *
  background-repeat: no-repeat;
  background-position:top 50% right 0px;
  background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='lightgray'/%3E%3C/svg%3E");
  text-overflow: ellipsis;
  overflow-x:hidden;
}
*/
/* 縦書き */
.varticalTitleMixed {
  text-orientation: mixed;
  writing-mode: vertical-rl;
}
.varticalTitleSideways {
  text-orientation: sideways;
  writing-mode: vertical-lr;
}
/* ツールチップ */
.errorCell {
  /* background-color: #ffe6ef!important; */
  background-color: #ff0000;
  position: relative;
  /* display: inline-block; */
  cursor: pointer;
}
/* ツールバー */
.customToolBar {
  background-color:#f3f3f3;
  border: 1px solid #ccc;
  margin: 4px 1px !important;
}
.customToolBarFixed {
  position: sticky;
  z-index: 10;
  top: 60px;
}
.right-input input {
  text-align: right;
}
/* ツールバーダイアログ用 */
.sps-section-title {
    margin-top: 0px;
    margin-left: 0px;
    padding-top: 4px;
    padding-left: 4px;
    padding-right: 4px;
    color: #4b4b4b;
    font-size: 0.875rem !important;
}
.sps-section-line {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-left: 4px !important;
    padding-right: 4px  !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 4px !important;
    margin-right: 4px  !important;
    border: 1px solid #83BDE5;
    background: #83BDE5 0% 0% no-repeat padding-box;
    opacity: 0.3;
}
</style>
